import "./Footer.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

import instagramIcon from "../../resources/icons/links/instagram.png";
import youtubeIcon from "../../resources/icons/links/youtube.png";
import tiktok from "../../resources/icons/links/tiktok.png";
import modulargridIcon from "../../resources/icons/links/modulargrid.png";

import logoSquare from "../../resources/images/logo.png";
import { footer, EMAIL_HREF } from "../../Data/siteContent";
import { LINKS } from "../../Data/apiEndpoints";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname !== "/") {
      navigate("/");
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="mobile-footer">
      <div className="footer-contacts">
        <div
          className={`footer-logo ${location.pathname !== "/" ? "footer-logo-clickable" : ""}`}
          onClick={handleLogoClick}
        >
          <img src={logoSquare} alt="Logo" className="footer-logo-img" />
        </div>

        <h4>{footer.contactsTitle}</h4>
        <p>
          <a href={EMAIL_HREF} className="footer-email-link">
            {footer.emailLinkText}
          </a>
        </p>

        <h4>{footer.legalsTitle}</h4>

        <div className="container-footer-links-legals">
          <Link to="/privacy-policy" className="privacy-policy-link">
            {footer.privacyPolicyLink}
          </Link>

          <Link to="/terms-conditions" className="privacy-policy-link">
            {footer.termsConditionsLink}
          </Link>
        </div>

        <h4>{footer.linksTitle}</h4>

        <div className="footer-social-icons">
          <a href={LINKS.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok">
            <img src={tiktok} alt="TikTok" className="social-icon-img" />
          </a>
          <a href={LINKS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
            <img src={instagramIcon} alt="Instagram" className="social-icon-img" />
          </a>
          <a href={LINKS.youtube} target="_blank" rel="noreferrer" aria-label="YouTube">
            <img src={youtubeIcon} alt="YouTube" className="social-icon-img" />
          </a>
          <a href={LINKS.modulargrid} target="_blank" rel="noreferrer" aria-label="ModularGrid">
            <img src={modulargridIcon} alt="ModularGrid" className="social-icon-img" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
